import { Reveal, Overline } from "../Reveal";

export default function Slide09Pricing() {
  return (
    <section className="slide bg-[var(--ais-cream)]" data-testid="slide-09">
      <div className="min-h-screen flex items-center px-6 md:px-16 lg:px-24 py-24">
        <div className="w-full max-w-6xl mx-auto">
          <Reveal>
            <Overline>09 — Pricing Position</Overline>
          </Reveal>
          <Reveal delay={1}>
            <div className="hairline w-16 my-8" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-espresso)] leading-[1.05] tracking-[-0.01em] font-light max-w-3xl">
              An <em className="italic">indicative</em> price band.
            </h2>
          </Reveal>
          <Reveal delay={3}>
            <p className="mt-6 font-sans text-[var(--ais-text)] text-base md:text-lg max-w-2xl leading-[1.85] font-light">
              The figures below are purely indicative — intended only to convey
              the brand&apos;s positioning. Each model will carry its own final
              price depending on materials, construction and edition.
            </p>
          </Reveal>

          <div className="mt-12 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--ais-gold-soft)] border border-[var(--ais-gold-soft)]">
            {[
              {
                tag: "Wholesale (per pair)",
                value: "$110 — $130",
                note: "Indicative band across the collection — actual price varies per model.",
              },
              {
                tag: "Suggested Retail",
                value: "$300 — $400",
                note: "Estimated final-consumer positioning, aligned with the Gulf quiet-luxury segment.",
              },
            ].map((c, i) => (
              <Reveal key={c.tag} delay={4 + i}>
                <div className="bg-[var(--ais-cream)] p-8 md:p-12 h-full flex flex-col min-h-[260px]">
                  <div className="font-sans text-[0.65rem] tracking-luxe uppercase text-[var(--ais-leather)]">
                    {c.tag}
                  </div>
                  <div className="mt-6 font-serif italic text-5xl md:text-6xl text-[var(--ais-espresso)] font-light leading-none">
                    {c.value}
                  </div>
                  <div className="mt-auto pt-8 font-sans text-sm text-[var(--ais-text)] leading-[1.75] font-light max-w-sm">
                    {c.note}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={7}>
            <p className="mt-8 font-sans italic text-xs text-[var(--ais-text)] opacity-80 max-w-2xl">
              * Prices in USD, ex-works Italy. Bands are indicative only — final
              pricing to be defined per model and per agreement.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
